import { shortcuts } from 'store/modules/panel_store/types';
import external_routes from 'services/external_routes';

export const CONLICITASEG_TOOL_LINK = '/conlicitaseg';

interface ToolLike {
  name?: string;
  link?: string;
}

export const isConlicitasegTool = (tool: ToolLike): boolean =>
  /conlicitaseg/i.test(tool?.name ?? '') || !!tool?.link?.startsWith(CONLICITASEG_TOOL_LINK);

export const CONLICITASEG_ACCESSIBLE_TOOL_LINKS: string[] = [
  external_routes.boletins,
  external_routes.licitacoes,
];

export const isConlicitasegAccessibleTool = (tool: ToolLike): boolean =>
  isConlicitasegTool(tool) || CONLICITASEG_ACCESSIBLE_TOOL_LINKS.includes(tool?.link ?? '');

export const FALLBACK_CONLICITASEG_TOOL: shortcuts = {
  id: -1,
  name: 'ConlicitaSeg',
  icon: 'conlicitaseg',
  link: CONLICITASEG_TOOL_LINK,
  category: 'Ferramentas de Gestão',
  tag_new: true,
  checked: true,
  default: true,
  created_at: '',
  updated_at: '',
};
